import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/attachment.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_f_close_circle.svg'
import _imports_2 from '@/app/ui/assets/svg/cloud-upload.svg'


const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-3 mr-3",
  alt: "attachment"
}, null, -1)
const _hoisted_3 = { class: "text-gray-lp-300" }
const _hoisted_4 = { class: "text-red-lp-2400 font-semibold whitespace-no-wrap" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4.41 4.41c.326-.325.854-.325 1.18 0L10 8.822l4.41-4.41c.326-.326.854-.326 1.18 0 .325.325.325.853 0 1.178L11.178 10l4.41 4.41c.326.326.326.854 0 1.18-.325.325-.853.325-1.178 0L10 11.177 5.588 15.59c-.325.326-.853.326-1.178 0-.326-.325-.326-.853 0-1.178L8.82 10l-4.41-4.41c-.326-.326-.326-.854 0-1.18z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_7 = {
  key: 2,
  class: "flex items-center gap-2"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-12 mb-2",
  alt: "upload"
}, null, -1)
const _hoisted_9 = { class: "flex flex-row items-center" }
const _hoisted_10 = { class: "text-red-lp-2400 font-semibold" }
const _hoisted_11 = {
  key: 0,
  class: "text-gray-lp-500"
}
const _hoisted_12 = {
  key: 2,
  class: "text-gray-lp-500"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "text-12px text-red-lp-1000" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Pastikan kembali format file sesuai ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" dan ukuran file tidak lebih dari ")
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", {
    class: "flex flex-col",
    style: _ctx.disabled ? 'opacity: 0.5;' : ''
  }, [
    (
        _ctx.fileName &&
          !_ctx.isDataValidate &&
          !_ctx.isDataRemoved &&
          _ctx.showPreviewImage &&
          _ctx.isFileImage
      )
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.fileName && !_ctx.disabled ? _ctx.$refs.file.click() : () => {})),
          onDragover: _cache[2] || (_cache[2] = (e) => _ctx.setDragAndDrop(e, true)),
          onDragleave: _cache[3] || (_cache[3] = (e) => _ctx.setDragAndDrop(e, false)),
          onDrop: _cache[4] || (_cache[4] = (e) => _ctx.onSubmitDrag(e)),
          class: 
        `
      ${_ctx.isDragFile ? 'border-gray-lp-600 bg-gray-lp-100' : 'border-gray-lp-400'}
      items-center text-12px flex flex-row justify-center ${
        _ctx.disabled ? 'cursor-not-allowed' : 'cursor-pointer'
      } border-2 border-dashed rounded mt-2`
      
        }, [
          _createVNode("img", {
            src: _ctx.fileImagePreview,
            class: "w-377px max-w-none",
            alt: ""
          }, null, 8, ["src"])
        ], 34))
      : (
        (_ctx.fileName &&
          !_ctx.isDataValidate &&
          !_ctx.isDataRemoved &&
          (!_ctx.showPreviewImage || !_ctx.isFileImage) &&
          _ctx.showFileDetail) ||
          _ctx.url
      )
        ? (_openBlock(), _createBlock("div", {
            key: 1,
            onClick: _cache[7] || (_cache[7] = ($event: any) => ((_ctx.fileName || _ctx.name) && !_ctx.disabled ? _ctx.$refs.file.click() : () => {})),
            onDragover: _cache[8] || (_cache[8] = (e) => _ctx.setDragAndDrop(e, true)),
            onDragleave: _cache[9] || (_cache[9] = (e) => _ctx.setDragAndDrop(e, false)),
            onDrop: _cache[10] || (_cache[10] = (e) => _ctx.onSubmitDrag(e)),
            class: 
        `
      ${_ctx.isDragFile ? 'border-gray-lp-600 bg-gray-lp-100' : 'border-gray-lp-400'}
      items-center text-12px justify-between flex flex-row ${
        _ctx.disabled ? 'cursor-not-allowed' : 'cursor-pointer'
      } border-2 border-dashed py-2 px-4 rounded my-2`
      
          }, [
            _createVNode("div", _hoisted_1, [
              _hoisted_2,
              _createVNode("div", _hoisted_3, _toDisplayString(_ctx.ellipsisString(_ctx.fileName.toString()).replaceAll("sign?path=", "") ||
              _ctx.ellipsisString(_ctx.name.toString()).replaceAll("sign?path=", "")), 1)
            ]),
            _createVNode("div", _hoisted_4, [
              (_ctx.loadingUpload)
                ? (_openBlock(), _createBlock("span", _hoisted_5, "Loading..."))
                : (_ctx.changeCustom)
                  ? (_openBlock(), _createBlock("svg", {
                      key: 1,
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (!_ctx.disabled ? _ctx.setDefault() : {})),
                      xmlns: "http://www.w3.org/2000/svg",
                      class: "w-4",
                      fill: "none",
                      viewBox: "0 0 20 20"
                    }, [
                      _hoisted_6
                    ]))
                  : (_openBlock(), _createBlock("span", _hoisted_7, [
                      (_ctx.isClearable)
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            class: "w-5 cursor-pointer",
                            src: _imports_1,
                            alt: "close_file_upload",
                            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.setDefault && _ctx.setDefault(...args)))
                          }))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(_ctx.titleChange), 1)
                    ]))
            ])
          ], 34))
        : (_openBlock(), _createBlock("div", {
            key: 2,
            onClick: _cache[11] || (_cache[11] = ($event: any) => (!_ctx.disabled ? _ctx.$refs.file.click() : {})),
            onDragover: _cache[12] || (_cache[12] = (e) => _ctx.setDragAndDrop(e, true)),
            onDragleave: _cache[13] || (_cache[13] = (e) => _ctx.setDragAndDrop(e, false)),
            onDrop: _cache[14] || (_cache[14] = (e) => _ctx.onSubmitDrag(e)),
            class: 
        `${_ctx.customClass} flex flex-col justify-center ${
          _ctx.disabled ? 'cursor-not-allowed' : 'cursor-pointer'
        } items-center text-12px border-2 border-dashed rounded-lg mt-2 ${
          _ctx.isDragFile
            ? 'border-gray-lp-600 bg-gray-lp-100'
            : (_ctx.isDataValidate && !_ctx.loadingUpload) ||
              (_ctx.isDataValidate && !_ctx.statusReset)
            ? 'border-red-lp-1000'
            : 'border-gray-lp-400'
        }`
      ,
            style: {"height":"140px"}
          }, [
            _hoisted_8,
            _createVNode("div", _hoisted_9, [
              _createVNode("span", _hoisted_10, _toDisplayString(_ctx.loadingUpload ? "Loading..." : "Click for upload"), 1),
              _withDirectives(_createVNode("span", { class: "text-gray-lp-500 ml-1" }, _toDisplayString(_ctx.$t("uploadFile.orDragAndDrop")), 513), [
                [_vShow, !_ctx.loadingUpload && _ctx.isDraggable && _ctx.showInfoDraggable]
              ])
            ]),
            (_ctx.caption)
              ? (_openBlock(), _createBlock("div", _hoisted_11, _toDisplayString(_ctx.caption), 1))
              : (_ctx.captionHtml)
                ? (_openBlock(), _createBlock("div", {
                    key: 1,
                    innerHTML: _ctx.captionHtml,
                    class: "text-gray-lp-500 text-center"
                  }, null, 8, ["innerHTML"]))
                : (_openBlock(), _createBlock("div", _hoisted_12, [
                    _createTextVNode(" ." + _toDisplayString(_ctx.type) + " up to ", 1),
                    (_ctx.type === 'pdf')
                      ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(_ctx.maxSize) + "MB", 1))
                      : (_openBlock(), _createBlock("span", _hoisted_14, _toDisplayString(_ctx.maxRowsData(_ctx.maxRows)) + " rows data ", 1))
                  ]))
          ], 34)),
    _createVNode("input", {
      type: "file",
      ref: "file",
      onChange: _cache[15] || (_cache[15] = (e) => (_ctx.isDragFile ? _ctx.onSubmitDrag(e) : _ctx.onSubmitClick(e))),
      accept: _ctx.acceptTypes,
      class: "hidden"
    }, null, 40, ["accept"]),
    _withDirectives(_createVNode("p", _hoisted_15, [
      (!!_ctx.errorColumnMessage)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            _createTextVNode(_toDisplayString(_ctx.errorColumnMessage), 1)
          ], 64))
        : (!!_ctx.errorMessage)
          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
            ], 64))
          : (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
              _hoisted_16,
              _withDirectives(_createVNode("span", null, [
                _hoisted_17,
                (_ctx.type === 'csv' || _ctx.type === 'xlsx')
                  ? (_openBlock(), _createBlock("span", _hoisted_18, _toDisplayString(_ctx.maxRowsData(_ctx.maxRows)) + " row data", 1))
                  : (_openBlock(), _createBlock("span", _hoisted_19, _toDisplayString(_ctx.maxSize) + "MB", 1))
              ], 512), [
                [_vShow, _ctx.isMax]
              ])
            ], 64))
    ], 512), [
      [_vShow, 
        (_ctx.isDataValidate || (_ctx.isDataValidate && !_ctx.url && !_ctx.statusReset)) &&
          _ctx.isShowRemarkError &&
          !_ctx.loadingUpload
      ]
    ])
  ], 4))
}